// extracted by mini-css-extract-plugin
module.exports = {"Testimonials":"TestimonialsBlock_Testimonials__2N8Ej","TestimonialsContainer":"TestimonialsBlock_TestimonialsContainer__3tgay"};